import { useState } from 'react';
import { JsonForms } from '@jsonforms/react';
import { materialCells } from '@jsonforms/material-renderers';

//import { renderers } from '@lk/form-renderer';

import FormRenderer from '@lk/form-renderer';

// локализация дейтпикера в JsonForms
import dayjs from 'dayjs';
import 'dayjs/locale/ru';
dayjs.locale("ru");


function PreviewTab ({schema, uiSchema, formViewMode, formData}) {
  
  //const [errors, setErrors] = useState([]);
  //const [data, setData] = useState(formData);

  //function handleFormChange ({ data, errors }) {
  //  setData(data);
  //  setErrors(errors); 
  //};

  //console.log(schema);
  //console.log(uiSchema)
  //console.log(formData)



  return (
    <div className='p-0'> {/*} style={{position: "relative", left: -10}}> */}
        <FormRenderer
          schema={schema}
          uiSchema={uiSchema}
          validationMode={'ValidateAndShow'}
          formViewMode={formViewMode}
          //handleFormChange={handleFormChange}
        />
    </div>
  )
}

export default PreviewTab